<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Create Resource</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <router-link to="/admin/resources" class="btn btn-primary" role="button">
                        back
                    </router-link>
                </div>
            </div>
          <form @submit.prevent="createResource" v-if="resource">
            <div class="row justify-content-md-center">
              <div class="col-12">
                <div class="row">
                  <div class="col-md-4" v-if="resourceType.length">
                    <fg-select
                      v-model="resource.resourceType"
                      label="Resource Type"
                      v-validate="rules.resourceType"
                      data-vv-name="Resource Type"
                      cus-name="Resource Type"
                      :has-errors="errors"
                      :is-fields="fields"
                      :list="resourceType"
                      selectedKey="id"
                    >
                    </fg-select>
                  </div>
                  <div class="col-md-8">
                    <fg-input type="text"
                              v-model="resource.imageUrl"
                              label="Image URL"
                              placeholder="Enter URL"
                              v-validate="rules.designation"
                              data-vv-name="designation"
                              cus-name="designation"
                              :has-errors="errors"
                              :is-fields="fields">
                    </fg-input>
                  </div>
                  <div class="col-md-12">
                    <fg-input type="text"
                              v-model="resource.articleHeader"
                              label="Article/Advertisement Header"
                              placeholder="Enter Header"
                    >
                    </fg-input>
                  </div>
                  <div class="col-md-12"  >
                    <fg-input type="text" v-if="!isAdvertisement"
                              v-model="resource.articleUrl"
                              label="Article URL"
                              placeholder="Enter URL"
                    >
                    </fg-input>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12"  v-if="!isAdvertisement">
                    <fg-text-area
                      rows="5"
                      v-model="resource.description"
                      label="Description"
                      placeholder="Description">
                    </fg-text-area>
                  </div>
                  <!--                      <b>{{resource.resourceType}}</b>-->
                  <div class="col-md-6" v-if="isAdvertisement">
                    <fg-input type="text"
                              v-model="resource.videoCode"
                              label="Video Code (Optional)"
                              placeholder="Enter Video Code"
                    >
                    </fg-input>
                  </div>
                  <div class="col-md-6" v-if="status.length">
                    <fg-select
                      v-model="resource.active"
                      label="Status"
                      v-validate="rules.status"
                      data-vv-name="Status"
                      cus-name="Status"
                      :has-errors="errors"
                      :is-fields="fields"
                      :list="status"
                      selectedKey="id"
                    >
                    </fg-select>
                  </div>
                </div>
              </div>
              <div class="col-6 text-center">
                <button type="submit" :disabled="errors.any()" class="btn btn-primary btn-fill btn-block">
                  Create Resource
                </button>
              </div>
            </div>
            <div class="clearfix"></div>
          </form>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import moment from 'moment'
    export default {
        name: 'CreateTestimonial',
        created (){
    },
    data () {
        return {
            resource: {
                resourceType: 1,
                articleHeader: '',
                articleUrl: '',
                imageUrl: '',
                description: '',
                videoCode: '',
                active: 1
            },
            isActive: 1,
          isAdvertisement: false,
            status: [{name:'Select Status'}, {id:"1", name:'Active'}, {id:"0", name:'Inactive'}],
          resourceType: [{id: "1", name:'Featured Article'}, {id: "2", name:'Set the TONE'}, {id: "3", name:'Advertisement Box'}],
            rules: {
              resourceType: {required : true},
              imageUrl: {required : true}
            },
            message: {
                error: false,
                text: ''
            }
        }
    },
      watch: {
        'resource.resourceType' (to, from) {
          if (this.resource.resourceType > 2) {
            this.isAdvertisement = true
            this.resource.description = ''
            this.resource.articleUrl = ''
          } else {
            this.isAdvertisement = false
            this.resource.videoCode = ''
          }
        }
      },
    methods: {
        createResource () {
          console.log("this.resource : ", this.resource);
          this.$validator.validateAll().then((result) => {
            if(result){
              this.$store.dispatch('ADD_RESOURCE', this.resource)
                .then((res) => {
                  console.log("ADD_RESOURCE res : ", res);
                  if(res) this.showPopup('Success!', 'Resource is successfully created', 'success', ()=>this.$router.push('/admin/resources'))
                  else this.showPopup('Error!', 'Unable to process.', 'error')
                })
                .catch(err => {
                  this.showPopup('Error!', 'some thing happen wrong', 'error')
                  console.log("ADD_RESOURCE API error : ", err);
                })
            }
          })
        },
        showPopup(title, msg, popupType, cb){
            this.$swal( title, msg, popupType
            ).then(res => {
                        cb && cb();
                        return res
                    })
        }
    },
    created() {

    },

    }
</script>

<style>
    .form-control{
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Resources/CreateResource.vue